import { Attributes, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class AssetProjectionCriteria extends Model.CriteriaBase {
    static typeName = "AssetProjectionCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = null;

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = null;

    public useNitAccountNumbers: boolean = false;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<AssetProjectionCriteria>) {
        super.addBusinessRules(rules);

        rules.failWhen(c => c.startDate !== null && c.endDate !== null && c.startDate >= c.endDate, "The end date must be after the start date.").onProperties(c => [c.startDate, c.endDate])
    }

    public toString(): string {
        return "Asset Projection Criteria";
    }
}